// @ts-nocheck
import React, { useRef } from "react";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import marker_icon from "leaflet/dist/images/marker-icon.png";
import marker_shadow from "leaflet/dist/images/marker-shadow.png";
import "./Map.css";
import SiteLogo from "../SiteLogo/SiteLogo";

function Map(props) {
	const mapRef = useRef();

	React.useEffect((old_props) => {
		if (
			props.updateOnRefocus !== false &&
			old_props?.points[0] !== props.points[0] &&
			mapRef
		)
			if (props.points?.length)
				mapRef.current?.setView(props.points[0], 13);
		if (
			old_props?.flyTo?.lat !== props.flyTo?.lat ||
			old_props?.flyTo?.lng !== props.flyTo?.lng
		)
			if (props.flyTo)
				mapRef.current?.flyTo(props.flyTo, props.flyTo.zoom);
	}, []);

	let DefaultIcon = L.icon({
		iconUrl: marker_icon,
		shadowUrl: marker_shadow,
		iconAnchor: [17, 46],
		popupAnchor: [-4, -30],
	});

	let points = props.points;
	if (!props.points?.length) {
		if (props.forcePoints) return false;
		points = [];
	}

	return (
		<div
			className={
				"map-cont" + (props.className ? " " + props.className : "")
			}
		>
			<MapContainer
				className="site-map"
				center={props.center ? props.center : props?.points[0]}
				zoom={props.zoom ? props.zoom : 13}
				flyTo={props.flyTo}
				whenCreated={(mapInstance) => {
					if (!mapRef?.current) mapRef.current = mapInstance;
					else if (mapRef.current !== mapInstance) {
						mapRef.current.remove();
						mapRef.current = mapInstance;
					}
				}}
			>
				{
					<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
				}
				{points?.map((a, key) => {
					return (
						<Marker key={key} position={a} icon={DefaultIcon}>
							<Popup>
								{props.popUp ? props.popUp : false}
								{props.popUpChild ? (
									<props.popUpChild {...a.popUpProps} />
								) : (
									false
								)}
							</Popup>
						</Marker>
					);
				})}
			</MapContainer>
		</div>
	);
}

export const SiteMapPopup = ({ site, img_url }) => {
	let website = site.website;
	if (website?.search(/(https|https)/gi) === -1)
		website = "https://" + website;
	return (
		<div className="d-flex site-popup flex-column">
			<div className="d-flex align-items-center">
				<SiteLogo
					className="me-3 site-logo"
					imgAlt={[site.siteName, site.address, site.country].join("-")}
					siteId={site.id}
					companyId={site.companyId}
					url={img_url}
				/>
				<div className="d-flex justify-content-between flex-column">
					<h4 className="title mb-1">{site.siteName}</h4>
					<div className="site-infos">
						<div>{site.address}</div>
						<div>
							{site.postalCode && site.postalCode !== "null"
								? site.postalCode
								: ""}
							{(site.postalCode && site.town ? " - " : "") +
								(site.town ?? "")}
						</div>
						<div>{site.country}</div>
						{(site.mail || site.phone || site.website) && (
							<>
								<hr className="mb-3" />
								{site.mail && site.mail !== "null" && (
									<div>
										Mail:{" "}
										<a href={"mailto:" + site.mail}>
											{site.mail}
										</a>
									</div>
								)}
								{site.phone && site.phone !== "null" && (
									<div>
										Téléphone:{" "}
										<a href={"tel:" + site.phone}>
											{site.phone}
										</a>
									</div>
								)}
								{site.website && site.website !== "null" && (
									<div>
										Site:{" "}
										<a
											href={website}
											rel="noreferrer"
											target="_blank"
										>
											{site.website}
										</a>
									</div>
								)}
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Map;
